import React from 'react';

const BasicLeaf = () => (
  <svg
    width="326"
    height="404"
    viewBox="0 0 326 404"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M64.3086 82.2963C-15.3763 148.133 -4.52486 324.198 10.8614 404C42.4441 316.716 248.944 354.123 302.391 256.864C345.149 179.057 320.207 53.2016 302.391 0C256.232 0 143.993 16.4593 64.3086 82.2963Z" />
  </svg>
);

export default BasicLeaf;
